import { render } from "./MfAddFile.vue?vue&type=template&id=bc04a2e8&scoped=true"
import script from "./MfAddFile.vue?vue&type=script&lang=js"
export * from "./MfAddFile.vue?vue&type=script&lang=js"

import "./MfAddFile.vue?vue&type=style&index=0&id=bc04a2e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc04a2e8"]])

export default __exports__